// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3WM_N","tab":"Tabs_tab__3NFgU","tabActive":"Tabs_tabActive__1KqMy"};